import React, { useState, useEffect } from "react";
import { Modal, Divider, Spin, Row, Col, Typography } from "antd";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import Icon from "@ant-design/icons";
import { getPhoneNumbersList } from "@redux/actionCreators/bookingSetup";
import { ReactComponent as PhoneCall } from "@assets/images/svg/phoneCall.svg";
import "@assets/styles/modal.scss";
import "../styles.scss";
import Loader from "@ui/feedback/loader";
import { DraggableTitle, DraggableWrapper } from "@ui/modals/draggable-wrapper";

const CallModal = ({ visibleFlag, children, personObjectId, top, candidateName = null }) => {
  const [isModalVisible, setIsModalVisible] = useState(visibleFlag);
  const dispatch = useDispatch();
  const [groupList, setGroupList] = useState();
  const reducerData = useSelector(state => state.bookingSetupReducer || null, shallowEqual);
  const {
    getPhoneNumbersList: { resultData: rd }
  } = reducerData;

  const {
    getPhoneNumbersList: { isLoading: getInfo }
  } = reducerData;

  useEffect(() => {
    setGroupList(rd?.Data);
  }, [rd]);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const getPhoneNumbers = () => {
    if (personObjectId !== undefined) {
      dispatch(getPhoneNumbersList(personObjectId));
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const modalHandler = () => {
    setIsModalVisible(!isModalVisible);
    getPhoneNumbers();
  };

  return (
    <div>
      <span
        onClick={() => {
          modalHandler();
        }}
        style={{ position: "relative", top: top }}
      >
        {children}
      </span>

      <Modal
        title={<DraggableTitle title={"Call"} />}
        modalRender={modal => <DraggableWrapper>{modal}</DraggableWrapper>}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        className="drs-modal-css"
        zIndex="1810"
      >
        {candidateName && (
          <>
            <Row>
              <Col style={{ margin: "0px", fontWeight: "bold" }}>
                <Typography>To: {candidateName}</Typography>
              </Col>
            </Row>
            <Divider type="horizontal" style={{ margin: "15px 0 15px 0" }} />
          </>
        )}

        <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>Phone Numbers</h3>
        <Spin
          style={{ position: "relative", top: "-5px" }}
          indicator={<Loader />}
          spinning={getInfo}
          className="loaderGifPosition"
        >
          {groupList !== undefined && (
            <>
              {groupList.map(({ PhoneNumber, PhoneNumberType, Description }, i) => (
                <p className="para_height" key={i}>
                  {PhoneNumber}
                  <Divider type="vertical" />
                  {PhoneNumberType}
                  <Divider type="vertical" />
                  {Description}
                  <a style={{ color: "black" }} href={`tel:${PhoneNumber}`}>
                    <Icon
                      style={{ cursor: "pointer" }}
                      component={PhoneCall}
                      className="status-icon alignIcon"
                    />
                  </a>
                  <Divider type="horizontal" style={{ margin: "15px 0 15px 0" }} />
                </p>
              ))}
            </>
          )}
          {groupList !== undefined && groupList.length === 0 ? (
            <>
              <p>No Phone Numbers available to make a call !</p>
            </>
          ) : null}
        </Spin>
      </Modal>
    </div>
  );
};

export default CallModal;
